import { numberOrStringToNumberSchema } from '@shared/schema/utils'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { z } from 'zod'

import { equipmentRefsGatewayQuery } from '@/queries/equipment-refs-gateway.query'
import { equipmentRefsSamplesQuery } from '@/queries/equipment-refs-samples.query'
import { equipmentRefsQuery } from '@/queries/equipment-refs.query'

const SearchSchema = z.object({
  equipmentRefId: numberOrStringToNumberSchema,
  category: z.union([z.literal('preventive'), z.literal('sample'), z.literal('cloudConnector')]),
})

export const Route = createFileRoute('/_dashboard/site/$id/equipment/create/')({
  validateSearch: SearchSchema,
  loaderDeps({ search }) {
    return {
      equipmentRefId: search.equipmentRefId,
      category: search.category,
    }
  },
  async loader({ deps: { equipmentRefId, category }, context: { queryClient } }) {
    let refs = []
    switch (category) {
      case 'cloudConnector': {
        refs = await queryClient.ensureQueryData(equipmentRefsGatewayQuery)

        break
      }

      case 'preventive': {
        refs = await queryClient.ensureQueryData(equipmentRefsQuery)

        break
      }

      case 'sample': {
        refs = await queryClient.ensureQueryData(equipmentRefsSamplesQuery)

        break
      }

      default: {
        throw notFound()
      }
    }

    const refToUse = refs.find((ref) => ref.id === equipmentRefId)

    if (!refToUse) {
      throw notFound()
    }

    return refToUse
  },
})
